import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","height":"95%","width":"100%","flex-direction":"column"} }

import { NewProfileStore } from '@/store/newProfileStore'
import BlockTitle from './BlockTitle.vue'
import { Plus, Delete, FullScreen } from '@element-plus/icons-vue'
import * as monaco from 'monaco-editor'

import { onMounted, ref, nextTick } from 'vue'

const BACNET_CODEC = `
function Decode(fPort, data, variables) {
    /* Add your decode code here */
    /* 
     * input:
     *   fPort: The fPort of the LoRaWAN message
     *   data: The raw data array of the LoRaWAN message payload
     *   variables: variables of the device
     * return: one or more decoded data item: 
     *   {
     *      channel: number,
     *      value: number
     *   }
     *   Eg. 
     *   return [{ channel: 1, value: 12.5 },{ channel: 2,value: 38}]
     */
    /****** START OF DECODE ******/
    return []
    /****** END OF DECODE *******/
}

function Encode(data, variables) {
     /* Add your encode code here */
     /* input:
      *   data: the data unit include the channel id & desired value :
      *   {
      *     channel: number,
      *     value: number
      *   }
      *   variables: other data units of this device with latest value:
      *     [{ channel: number, value: number } ...]
      *     
    /****** START OF ENCODE ******/

    /****** END OF ENCOD ********/
}


function decodeUplink(input) {
    return {
        data: Decode(input.fPort, input.bytes, input.variables)
    }
}

function encodeDownlink(input) {
    return {
        bytes: Encode(input.data, input.variables)
    }
}`


export default /*#__PURE__*/_defineComponent({
  __name: 'CodeEditor',
  setup(__props, { expose: __expose }) {

const profileStore = new NewProfileStore()
const fullScreen = ref(false)
const monacoEditorContainer = ref()
const fullscreenEditorDiv = ref()
let editorInstance:any
let fullscreenEditorInstance: any

const editor = () => {
  const codec = profileStore.GetCodec()
  if (monacoEditorContainer.value) {
    editorInstance = monaco.editor.create(monacoEditorContainer.value, {
      theme: 'vs-light',
      value: codec || BACNET_CODEC,
      language: 'javascript',
      folding: true,
      foldingHighlight: true,
      foldingStrategy: 'indentation',
      showFoldingControls: 'always',
      disableLayerHinting: true,
      emptySelectionClipboard: false,
      selectionClipboard: false,
      automaticLayout: true,
      codeLens: false,
      fontSize: 14,
      scrollBeyondLastLine: false,
      colorDecorators: true,
      accessibilitySupport: 'off',
      lineNumbers: 'on',
      lineNumbersMinChars: 5,
      readOnly: false
    })
  }
}

const Submit = async () => {
  return new Promise<void>((resolve, reject) => {
    profileStore.SubmitCodec(editorInstance.getValue()).then(() => {
      resolve()
    }).catch(err => {
      reject(err)
    })
  })
}

const OnExitFullscreen = () => {
  editorInstance.setValue(fullscreenEditorInstance.getValue())
  fullScreen.value = false
}
const OnFullScreen = () => {
  fullScreen.value = true
  if (fullscreenEditorInstance) {
    fullscreenEditorInstance.setValue(editorInstance.getValue())
  } else {
    nextTick(() => {
      fullscreenEditorInstance = monaco.editor.create(fullscreenEditorDiv.value, {
        theme: 'vs-light',
        value: editorInstance.getValue(),
        language: 'javascript',
        folding: true,
        foldingHighlight: true,
        foldingStrategy: 'indentation',
        showFoldingControls: 'always',
        disableLayerHinting: true,
        emptySelectionClipboard: false,
        selectionClipboard: false,
        automaticLayout: true,
        codeLens: false,
        fontSize: 14,
        scrollBeyondLastLine: false,
        colorDecorators: true,
        accessibilitySupport: 'off',
        lineNumbers: 'on',
        lineNumbersMinChars: 5,
        readOnly: false
      })
    })
  }
}

__expose({ Submit })

onMounted(() => {
  editor()
})

return (_ctx: any,_cache: any) => {
  const _component_ElIcon = _resolveComponent("ElIcon")!
  const _component_ElRow = _resolveComponent("ElRow")!
  const _component_ElCol = _resolveComponent("ElCol")!
  const _component_ElButton = _resolveComponent("ElButton")!
  const _component_ElDialog = _resolveComponent("ElDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BlockTitle, {
      title: "Decode/Encode Script",
      description: "Edit JavaScript scripts to extract datapoint values from LoRaWAN raw data or convert datapoint values into LoRaWAN raw Data."
    }),
    _createVNode(_component_ElRow, null, {
      default: _withCtx(() => [
        _createVNode(_component_ElCol, { span: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_ElRow, { justify: "end" }, {
              default: _withCtx(() => [
                _createVNode(_component_ElIcon, {
                  onClick: OnFullScreen,
                  style: {"margin-bottom":"12px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(FullScreen))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", {
              id: "editor",
              ref_key: "monacoEditorContainer",
              ref: monacoEditorContainer,
              style: {"width":"900px","min-height":"400px"}
            }, null, 512)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ElDialog, {
      modelValue: fullScreen.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fullScreen).value = $event)),
      fullscreen: true,
      class: "fullscreen-dialog",
      "show-close": false
    }, {
      header: _withCtx(() => [
        _createVNode(_component_ElRow, { justify: "end" }, {
          default: _withCtx(() => [
            _createVNode(_component_ElIcon, {
              size: 16,
              onClick: OnExitFullscreen
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(FullScreen))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            id: "fullScreenEiditor",
            ref_key: "fullscreenEditorDiv",
            ref: fullscreenEditorDiv
          }, null, 512),
          _createVNode(_component_ElRow, {
            justify: "center",
            style: {"margin-top":"12px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ElButton, {
                onClick: OnExitFullscreen,
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Close")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})